import { render } from "./ModalMessage.html?vue&type=template&id=314108ca&scoped=true"
import script from "./ModalMessage.js?vue&type=script&lang=js"
export * from "./ModalMessage.js?vue&type=script&lang=js"

import "./ModalMessage.css?vue&type=style&index=0&id=314108ca&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314108ca"]])

export default __exports__